export const SORT_BY_PRICE_LOWEST = 'price_asc';
export const SORT_BY_ARRIVAL_EARLIEST = 'arrival_asc';
